import openLiveChat from "util/chat-widget/open-live-chat";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

export const CardData = [
  {
    imgSrc: getRelativeImagePath("/images/public/chatUser.webp"),
    title: "Need Help?",
    heading: "Chat with auto parts experts",
    buttonText: "Chat now",
    buttonAction: openLiveChat,
    alt: "Connect with Our Customer Support for Assistance and Answers",
    color: "success-secondary",
    ctaIcon: "chat",
  },
  {
    imgSrc: getRelativeImagePath("/images/public/pa_DeliveryTruck.webp"),
    title: "Free Shipping",
    heading: "On order above $99",
    buttonText: "Read more",
    buttonUrl: "/auto-parts-free-shipping-canada",
    alt: "FREE 1-3 day delivery over $99* on all auto parts orders",
    color: "pa-blue",
  },
];
